import useWindowsSize from "@/Hooks/useWindowsSize";
import Skeleton from "react-loading-skeleton";

export const DefaultPdp = (): JSX.Element => {
  const { width } = useWindowsSize();
  return (
    <div className="ps-product--detail ps-product--fullwidth">
      <div className="ps-page--product">
        <div className="ps-container">
          <div className="ps-page__container">
            <div className="ps-page__left">
              <div className="ps-product--detail ps-product--fullwidth">
                <div className="ps-product__header container__thumbnail">
                  {width >= 1200 ? (
                    <Skeleton
                      className="top-img-pdp--skeleton w-100"
                      width={1300}
                      height={1300}
                    />
                  ) : (
                    <figure>
                      <div className="ps-wrapper">
                        <div className="ps-product__gallery">
                          <Skeleton className="top-img-pdp--skeleton w-100" />
                        </div>
                      </div>
                    </figure>
                  )}
                </div>
                <div className="product__info">
                  <h1 className="text-style ellipsis-product-name">
                    <Skeleton
                      className="develop_title_pdp_skeleton mt-3"
                      //height={33}
                    />
                  </h1>
                  <div className="d-flex flex-column mb-2">
                    <div className="p-0">
                      <Skeleton className="p-3 mt-2" />
                    </div>
                    <div className="p-0 w-100">
                      <Skeleton className="p-3 mt-2" />
                    </div>
                    <div className="p-0 w-100">
                      <Skeleton className="p-3 mt-3" />
                    </div>
                  </div>
                  <div className="">
                    <figure>
                      <figcaption>
                        <figcaption>
                          <Skeleton className="p-3 w-25" />
                        </figcaption>
                      </figcaption>
                      <Skeleton className="p-4 mt-2 w-25" />
                    </figure>
                    {width >= 1200 ? (
                      <Skeleton className="ps-btn develop__buttons mt-2 w-25" />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="ps-product__content ps-tab-root">
                    <ul className="ps-tab-list mt-2">
                      <li className="w-25">
                        <Skeleton className="p-3" />
                      </li>
                      <li className="w-25 ml-2">
                        <Skeleton className="p-3" />
                      </li>
                    </ul>
                    <div className="ps-tabs">
                      <div className="ps-tab active">
                        <div className="ps-document text-justify">
                          <Skeleton className="develop-description--skeleton" />
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
